/* eslint-disable jsx-a11y/img-redundant-alt */
/* eslint-disable no-undef */
/* eslint-disable react/no-unescaped-entities */
/* eslint-disable no-unused-vars */

import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import {
  Avatar_16,
  Avatar_02,
  Avatar_05,
  Avatar_09,
  Avatar_10,
} from "../../../Routes/ImagePath/index";

import { Link } from "react-router-dom";
import Select from "react-select";
import { useTranslation } from "react-i18next";

import React, { useState, useEffect, useRef } from "react";

import AuthUser from "../../AuthUser";

import { toast, ToastContainer } from "react-toastify";

import Spinner from "../../Spinner";

import Swal from "sweetalert2";

import { Alert } from "react-bootstrap";

const CrewChangeEditModal = ({ onSubmissionSuccess, crew_change }) => {
  const { t } = useTranslation();

  // eslint-disable-next-line no-unused-vars
  const {
    http,
    url_root,
    user,
    user_permissoes,
    verificarPermissao,
    getMissao,
  } = AuthUser();

  const fileInputRef = useRef(null);

  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);

  const [plano, setPlan] = useState([]);
  const [planos, setPlanos] = useState([]);
  const [postos, setpostos] = useState([]);
  const [posto_id, setposto] = useState("");
  const [projects, setProjects] = useState([]);
  const [project_id, setProject] = useState(0);

  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");

  const [tipo, setTipo] = useState(1);

  const [validators, setValidators] = useState([]);

  const [searchEmployee, setSearchEmployee] = useState("");
  const [selectedEmployee, setSelectedEmployee] = useState("");
  const [selectedTraining, setSelectedTraining] = useState("");

  const [uploadedFile, setUploadedFile] = useState(null);

  const [cargos, setCargos] = useState([]);
  const [departamentos, setDepartamentos] = useState([]);
  const [comapnys, setCompanys] = useState([]);

  const [termo_pesquisa, setSelectedTermoPesquisa] = useState("");
  const [selectedCompany, setSelectedCompany] = useState("-1");
  const [selectedCargo, setSelectedCargo] = useState("-1");
  const [selectedDepartamento, setSelectedDepartamento] = useState("-1");

  useEffect(() => {

    getPostos();
    getColaboradores();
    setSelectedEmployee("");

    setTipo(crew_change?.tipo);
    setposto(crew_change?.posto_id);
    setSelectedEmployee(crew_change?.colaborador_id);
    setStartDate(crew_change?.data_emissao);
    setEndDate(crew_change?.data_expiracao);

  }, [crew_change]);

  const getColaboradores = async () => {
    try {
      setLoading(true); // Set loading to true when the request starts

      const res = await http.get("/utilizadores/ativados/" + getMissao()?.id);

      setValidators(res.data.utilizadores);

      setLoading(false);
    } finally {
      setLoading(false); // Set loading to false when the request is complete (either success or error)
    }
  };

  const getpostos = async () => {
    setLoading(true);

    try {
      const res = await http.get("/listar-postos-ativos");

      console.log("postos  :");
      console.log(res);

      setpostos(res?.data?.postos);
    } catch (error) {
      setLoading(false);
      console.log("Error loading trainings.");
    } finally {
      setLoading(false);
    }
  };

  const handleFileUpload = (e) => {
    const file = e.target.files[0];

    if (!file) return;

    const allowedTypes = [
      "application/msword", // .doc
      "application/vnd.openxmlformats-officedocument.wordprocessingml.document", // .docx
      "application/vnd.ms-excel", // .xls
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet", // .xlsx
      "text/csv", // .csv
      "application/pdf", // .pdf
    ];

    if (!allowedTypes.includes(file.type)) {
      alert(
        "Formato inválido. Apenas DOC, DOCX, XLS, XLSX, CSV e PDF são permitidos."
      );
      return;
    }

    setUploadedFile(file);
  };

  const handleSubmitEmployeeToEnroll = async () => {
    if (!startDate || !endDate) return notifyError("Fill all dates in form.");

    if (!selectedEmployee || Number(selectedEmployee) <= 0)
      return toast.error("please set an employee.");

    if (!posto_id || Number(posto_id) <= 0)
      return toast.error("please set a training.");

    const start = new Date(startDate).toISOString().split("T")[0];
    const end = new Date(endDate).toISOString().split("T")[0];

    if (end <= start) {
      return notifyError("Expire Date must be later than Emission Date .");
    }

    try {
      setLoading(true);

      const formData = new FormData();

      formData.append("id", crew_change?.id);
      formData.append("posto_id", posto_id);
      formData.append("colaborador_id", selectedEmployee);
      formData.append("tipo", tipo);
      formData.append("data_emissao", startDate);
      formData.append("data_expiracao", endDate);

      const res = await http.post("/update-crew-change", formData, {
        headers: { "Content-Type": "multipart/form-data" },
      });

      setLoading(false);

      setSelectedEmployee("");
      setSelectedTraining("");
      setStartDate("");
      setEndDate("");
      setUploadedFile(null);

      toast.success(res.data.message, {
        position: "top-right",
        autoClose: 1000,
        hideProgressBar: false,
        closeOnClick: true,
        pauseOnHover: true,
        draggable: true,
        onClose: () => {
          triggerCloseButtonClick("closeButton30");
          onSubmissionSuccess(res?.data?.crew_changes);
        },
      });
    } catch (error) {
      console.error(error);
      console.log(error?.message);
      setLoading(false);
    }
  };

  const getPostos = async () => {
    setLoading(true);

    try {
      const res = await http.get("/listar-postos-ativos/" + getMissao()?.id);

      console.log("postos  :");
      console.log(res);

      setpostos(res?.data?.postos);
    } catch (error) {
      setLoading(false);
      console.log("Error loading postos.");
    } finally {
      setLoading(false);
    }
  };

  const triggerCloseButtonClick = (buttonId) => {
    const closeButton = document.getElementById(buttonId);
    if (closeButton) {
      closeButton.dispatchEvent(new Event("click"));
    }
  };

  const handleImageClick = () => {
    if (fileInputRef.current) {
      fileInputRef.current.click();
    }
  };

  return (
    <>
      {/* Add Task Modal */}
      <div
        id="edit_crew_change_modal"
        className="modal custom-modal fade modal-lg"
        role="dialog"
      >
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-header">
              <h4 className="modal-title">{t("Atualizar Crew Change")}</h4>
              <button
                type="button"
                className="btn-close"
                data-bs-dismiss="modal"
                id="closeButton30"
              >
                ×
              </button>
            </div>
            <div className="modal-body">
              {/* OPEN ROW */}
              <div className="row">
                <div className="col-xl-12 mb-3">
                  {loading && (
                    <div className="alert alert-primary text-center my-3">
                      <i className="fa fa-spinner fa-spin me-2"></i>{" "}
                      Carregando...
                    </div>
                  )}
                </div>

                <div className="container-fluid">
                  <form>
                    {/* Search Employee */}
                    {!loading ? (
                      <>
                        <div className="row">
                          <hr></hr>

                          <div className="col-xl-12 mb-3">
                            {loading && (
                              <div className="alert alert-primary text-center my-3">
                                <i className="fa fa-spinner fa-spin me-2"></i>{" "}
                                Loading...
                              </div>
                            )}
                          </div>

                           <div className="col-xl-12 mb-3">
                            <label className="form-label">
                              Tipo{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="default-select form-control"
                              value={tipo}
                              onChange={(e) =>
                                setTipo(e.target.value)
                              }
                            >
                              <option value="">
                                Selecione o tipo
                              </option>
                            <option value="1">
                                Entrada
                              </option>

                              <option value="2">
                                Saida
                              </option>
                            </select>
                          </div>

                          <div className="col-xl-12 mb-3">
                            <label className="form-label">
                              Colaboradores{" "}
                              <span className="text-danger">*</span>
                            </label>
                            <select
                              className="default-select form-control"
                              value={selectedEmployee}
                              onChange={(e) =>
                                setSelectedEmployee(e.target.value)
                              }
                            >
                              <option value="">
                                Select [ colaborador - cargo ]
                              </option>
                              {validators.map((validator) => (
                                <option key={validator?.id} value={validator?.id}>
                                  {validator?.name} - {validator?.matricula} - (
                                  {validator?.cargo?.designacao})
                                </option>
                              ))}
                            </select>
                          </div>
                        </div>
                      </>
                    ) : (
                      <></>
                    )}

                    {/* Select Training */}
                    <div className="row">
                      <div className="col-xl-12 mb-3">
                        <label className="form-label">
                          Projetos <span className="text-danger">*</span>
                        </label>

                        <select
                          className="default-select form-control"
                          value={posto_id}
                          onChange={(e) => setposto(String(e.target.value))}
                        >
                          <option value="">Selecione o projeto</option>
                          {!loading &&
                            postos.map((posto) => (
                              <option key={posto.id} value={posto.id}>
                                {posto.codigo} - {posto.nome} -{" "}
                                {posto?.cliente?.nome}
                              </option>
                            ))}
                        </select>
                      </div>

                      <div className="col-xl-6 mb-3">
                        <label className="form-label">
                          Data <span className="text-danger">*</span>
                        </label>
                        <input
                          onChange={(e) => setStartDate(e.target.value)}
                          className="form-control"
                          type="date"
                          value={startDate}
                        />
                      </div>

                      {tipo == 1 ? (
                        <div className="col-xl-6 mb-3">
                          <label
                            htmlFor="exampleFormControlInput8"
                            className="form-label"
                          >
                            Data previsão de saida{" "}
                            <span className="text-danger">*</span>
                          </label>
                          <input
                            onChange={(e) => setEndDate(e.target.value)}
                            className="form-control"
                            type="date"
                            value={endDate}
                          />
                        </div>
                      ) : (
                        <></>
                      )}
                    </div>
                  </form>

                  <div>
                    {loading ? (
                      <button type="button" className="btn btn-primary me-1">
                        <i className="fa fa-spinner fa-spin"></i> Enviando...
                      </button>
                    ) : (
                      <button
                        onClick={handleSubmitEmployeeToEnroll}
                        type="button"
                        className="btn btn-primary me-1"
                      >
                        Atualizar
                      </button>
                    )}
                    <Link
                      href={"#"}
                      onClick={() => setShowModal(false)}
                      className="btn btn-danger light ms-1"
                    >
                      Cancelar
                    </Link>
                  </div>
                </div>

                {/* CLOSE ROW */}
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Add Task Modal */}

      <ToastContainer />
    </>
  );
};

export default CrewChangeEditModal;
